export default __webpack_public_path__ + "static/media/logo_horizontal.d9a9a6a4.png";